import { render, staticRenderFns } from "./PatentStatus.vue?vue&type=template&id=84c434f4&"
import script from "./PatentStatus.vue?vue&type=script&lang=js&"
export * from "./PatentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports